import styled from "styled-components";

export const JackpotBetWidgetGradientBackgroundTextDefaultBox = styled.div`
  background: linear-gradient(69.59deg, #9747FF 8.41%, #FCE403 47.91%, #7FF800 82.48%);
  width: fit-content;
  
  border-radius: 30px;
  padding: 4px 12px;
  
  align-self: center;
  backdrop-filter: blur(3px);
  
  
  box-shadow: 0 2px 8px 0 #1F0861BF,
  inset 0 0 2px 0 #7FF800,
  inset 0 -1px 10px 0px #FCE403;

  font-size: 3.2rem;
  font-weight: 900;
  line-height: 38.4px;
  letter-spacing: -0.5px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  text-shadow: 0 0 5px #FCE403;
  
`;
